import React, { useState, useRef, useEffect } from "react";
import "./custom-tooltip.css";

export const CustomTooltip = ({ children, content, type = "default", disabled = false, containerStyle = {}, tooltipStyle = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const containerRef = useRef(null);

  const updatePosition = () => {
    if (containerRef.current && tooltipRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      let top = containerRect.top - tooltipRect.height - 16;
      let left = containerRect.left + (containerRect.width - tooltipRect.width) / 2;

      // Ajustements pour éviter le débordement de l'écran
      const margin = 20; // Marge de sécurité
      if (left < margin) {
        left = margin;
      }
      if (left + tooltipRect.width > window.innerWidth - margin) {
        left = window.innerWidth - tooltipRect.width - margin;
      }

      // Si pas de place au-dessus, afficher en dessous
      if (top < margin) {
        top = containerRect.bottom + 16;
      }

      // Vérifier aussi qu'il y a de la place en dessous
      if (top + tooltipRect.height > window.innerHeight - margin) {
        top = containerRect.top - tooltipRect.height - 16;
      }

      setPosition({ top, left });
    }
  };

  const handleMouseEnter = () => {
    setIsVisible(true);
    setTimeout(updatePosition, 1);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isVisible) {
        updatePosition();
      }
    };

    const handleResize = () => {
      if (isVisible) {
        updatePosition();
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", handleResize);
    };
  }, [isVisible]);

  const getTooltipStyles = () => {
    let baseStyles = "custom-tooltip-content";

    if (disabled) {
      baseStyles += " tooltip-disabled";
    } else if (type === "success") {
      baseStyles += " tooltip-success";
    } else if (type === "warning") {
      baseStyles += " tooltip-warning";
    } else if (type === "info") {
      baseStyles += " tooltip-info";
    } else {
      baseStyles += " tooltip-default";
    }

    return baseStyles;
  };
  return (
    <div
      ref={containerRef}
      className="custom-tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        display: "inline-block",
        position: "relative",
        ...containerStyle,
      }}
    >
      {children}
      {isVisible && content && (
        <div
          ref={tooltipRef}
          className={getTooltipStyles()}
          style={{
            position: "fixed",
            top: position.top,
            left: position.left,
            zIndex: 99999,
            pointerEvents: "none",
            ...tooltipStyle,
          }}
        >
          
          <div className="tooltip-arrow"></div>
          <div className="tooltip-text">
            {typeof content === "string" ? (
              content.split("\n").map((line, index) => (
                <div key={index} className={index === 0 ? "tooltip-title" : "tooltip-description"}>
                  {line}
                </div>
              ))
            ) : (
              <div className="tooltip-description">{content}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
